import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { MailX, Check } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Seo } from '../components/Seo';
import { api } from '../lib/api';

const Unsubscribe = () => {
  const { token } = useParams();
  const [state, setState] = useState('loading');

  useEffect(() => {
    api.get(`/newsletter/unsubscribe/${token}`).then((r) => setState(r.data.removed ? 'done' : 'gone')).catch(() => setState('error'));
  }, [token]);

  return (
    <div className="bg-black min-h-screen text-white flex flex-col" data-testid="unsubscribe-page">
      <Seo title="Avmelding nyheitsbrev | Refuel Weekend" description="Meld deg av nyheitsbrevet." path="/nyheitsbrev/avmeld" noindex />
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md w-full rounded-3xl bg-[#0f0a17] border border-white/10 p-8 text-center">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-[#ff2e2e]/15 text-[#ff2e2e] flex items-center justify-center mb-5">{state === 'done' ? <Check size={30} /> : <MailX size={30} />}</div>
          <h1 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: "'Oktah Round', sans-serif" }} data-testid="unsubscribe-status">
            {state === 'loading' && 'Melder deg av…'}
            {state === 'done' && 'Du er meldt av'}
            {state === 'gone' && 'Du er allereie meldt av'}
            {state === 'error' && 'Noko gjekk gale'}
          </h1>
          <p className="text-white/60 mb-6">Du vil ikkje få fleire nyheitsbrev frå Refuel Weekend. Du kan melde deg på igjen når som helst nedst på framsida.</p>
          <Link to="/" className="inline-flex px-6 py-3 rounded-full bg-[#ff2e2e] text-black font-bold">Til framsida</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Unsubscribe;
